module.exports = __webpack_public_path__ + "img/diagnose3.47671674.jpg";